import { LocationForm } from "./LocationForm";

export function LocationCreatePage() {
  return <LocationForm mode="create" />;
}
